import React from "react";
import { Container } from "react-bootstrap";
import { MdWorkOutline } from "react-icons/md";
import "./WorkExperience.css";

const JOBS = [
  {
    role: "PLDG Cohort 2 Contributor",
    company: "Protocol Labs",
    dates: "Jan – Apr 2026",
    points: [
      "Contributed to the Storacha team (formerly web3.storage) on decentralized hot-storage layers.",
      "Worked on data retrieval and reliability with IPFS and Filecoin across large-scale distributed systems.",
    ],
    tags: ["IPFS", "Filecoin", "Distributed Systems"],
  },
  {
    role: "Software Engineering Intern",
    company: "Dukaan",
    dates: "Aug – Dec 2024",
    points: [
      "Built a customer-support AI agent and cut response latency 4x with real-time HTTP streaming.",
      "Set up CI/CD with GitHub Actions and Docker to catch model-behaviour regressions before production.",
    ],
    tags: ["Next.js", "Express.js", "AI Agents", "CI/CD"],
  },
];

function WorkExperience() {
  return (
    <Container fluid className="work-section" id="experience">
      <Container>
        <h1 className="project-heading" style={{ paddingBottom: "30px" }}>
          Work <strong className="purple">Experience</strong>
        </h1>
        <div className="work-timeline">
          {JOBS.map((job) => (
            <div className="work-item" key={job.company}>
              <div className="work-dot">
                <MdWorkOutline />
              </div>
              <div className="work-card">
                <div className="work-head">
                  <div>
                    <h4 className="work-role">{job.role}</h4>
                    <h5 className="work-company">{job.company}</h5>
                  </div>
                  <span className="work-dates">{job.dates}</span>
                </div>
                <ul className="work-points">
                  {job.points.map((p) => (
                    <li key={p}>{p}</li>
                  ))}
                </ul>
                <div className="work-tags">
                  {job.tags.map((t) => (
                    <span className="work-tag" key={t}>{t}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </Container>
  );
}

export default WorkExperience;
